import BaseApi from '../../../api/BaseApi';

const surveyBasePath = '/engagement/survey/theme';

class SurveyThemeApi {
  static themeList(param) {
    return BaseApi.get(`${surveyBasePath}?layout=${param}`);
  }
  static themeCreate(body) {
    return BaseApi.post(`${surveyBasePath}/`, body);
  }
  static themeView(id) {
    return BaseApi.get(`${surveyBasePath}/${id}`);
  }
}

export default SurveyThemeApi;
